
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import ExpertiseSelector from "../../../common/expertise/selector/ExpertiseSelector";

async function loadWebinarExpertises(webinarId) {
	try {
		const result = await api.listWebinarExpertises({
			webinar_id: webinarId,
		});
		if (result?.all_expertises?.length) {
			return {
				all: result.all_expertises,
				active: (result.active_expertises ?? []).map((e) => e.id),
			};
		}
	} catch {
		// endpoint may be unavailable until backend is deployed
	}
	const all = await api.expertiseList();
	const list = Array.isArray(all) ? all : [];
	return { all: list, active: [] };
}

export default function FieldExpertise({ onChange, webinar, isDesktop }) {
	const [expertises, setExpertises] = useState([]);
	const [activeExpertiseIds, setActiveExpertiseIds] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const webinarId = webinar?.id;

	useEffect(() => {
		let cancelled = false;
		setIsLoading(true);
		setErrorMessage("");
		loadWebinarExpertises(webinarId)
			.then(({ all, active }) => {
				if (cancelled) return;
				setExpertises(all);
				setActiveExpertiseIds(active);
				onChange(active);
			})
			.catch((err) => {
				if (cancelled) return;
				if (err?.data?.message) {
					setErrorMessage(err.data.message);
				} else {
					setErrorMessage("دریافت تخصص‌ها ناموفق بود");
				}
			})
			.finally(() => {
				if (!cancelled) setIsLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [webinarId]);

	if (isLoading) {
		return (
			<p className="text-center font-Vazir-400 text-[14px] text-darkBlue/50">
				در حال بارگذاری تخصص‌ها…
			</p>
		);
	}

	if (expertises.length === 0) {
		return (
			<p className="text-center font-Vazir-400 text-[14px] text-darkBlue/50">
				{errorMessage || "تخصصی برای انتخاب وجود ندارد."}
			</p>
		);
	}

	return (
		<div>
			<ExpertiseSelector
				expertises={expertises}
				initActiveExpertiseIds={activeExpertiseIds}
				onChange={onChange}
				isDesktop={isDesktop}
			/>
			{errorMessage && (
				<div className="mt-2 text-center font-Vazir-400 text-[#cc0000]">
					{errorMessage}
				</div>
			)}
		</div>
	);
}
